<template>
  <div id="container">
    <div class="title">Breakroom Voice and Video Tester</div>
    <div class="subTitle">
      <div>
        <div class="itemsTitle">General Troubleshooting?</div>
        <div class="itemsInner">
          We have a
          <a
            href="https://docs.sine.space/world-streaming/troubleshooting"
            target="_blank"
            >dedicated troubleshooting guide</a
          >
          for World Streaming available.
        </div>
      </div>
      <div>
        <div class="itemsTitle">macOS User?</div>
        <div class="itemsInner">
          You may need to enable microphone and video permissions, see
          <a
            href="https://docs.sine.space/world-streaming/macos-permissions"
            target="_blank"
            >this page for details</a
          >.
        </div>
      </div>
    </div>
    <div class="body">
      <div class="videoCol">
        <div class="itemsTitle">Video Test Feed</div>
        <div class="contentBody">
          <div class="itemContent">
            <div class="midTitle">Video</div>
            <div>
              <select @change="cameraChange" v-model="cameraSelected">
                <option
                  v-for="(device, i) in cameraDevices"
                  :value="device.value"
                  :key="i"
                >
                  {{ device.label }}
                </option>
              </select>
            </div>
            <div class="itemsInner" v-show="videoError.length > 0">
              {{ videoError }}
            </div>
            <video
              id="localWebcamVideo"
              width="100%"
              height="auto"
              autoplay="autoplay"
            ></video>
          </div>
          <hr />

          <div class="itemContent contentFlex">
            <div>
              <img
                :src="videoError.length > 0 ? checkWrongImg : checkRightImg"
              />
            </div>
            <div>
              <div class="midTitle">Video Device</div>
              <div class="itemsInner">{{ videoName }}</div>
              <div class="itemsInner">
                (No Device / Unauthorized) Wrong or missing device?
                <a
                  href="https://docs.sine.space/world-streaming/troubleshooting#no-devices-detected-wrong-device"
                  target="_blank"
                >
                  Click here for tips
                </a>
              </div>
            </div>
          </div>
          <hr />
          <div class="itemContent contentFlex">
            <div>
              <img
                :src="
                  videoNetworking != 'Connection Established'
                    ? checkWrongImg
                    : checkRightImg
                "
              />
            </div>
            <div>
              <div class="midTitle">Video Networking</div>
              <div class="itemsInner">{{ videoNetworking }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="textCol">
        <div class="itemsTitle">Audio Test Feed</div>
        <div class="contentBody">
          <div class="itemContent">
            <div class="midTitle">Audio</div>
            <div>
              <select @change="inputChange" v-model="microphoneSelected">
                <option
                  v-for="(device, i) in inputDevices"
                  :value="device.value"
                  :key="i"
                >
                  {{ device.label }}
                </option>
              </select>
            </div>
            <div class="itemsInner" v-show="audioError.length > 0">
              {{ audioError }}
            </div>
          </div>
          <hr />
          <div class="itemContent contentFlex">
            <div>
              <img
                :src="audioError.length > 0 ? checkWrongImg : checkRightImg"
              />
            </div>
            <div>
              <div class="midTitle">Audio Device</div>
              <div class="itemsInner">{{ audioName }}</div>
              <div class="itemsInner">
                (No Device / Unauthorized) Wrong or missing device?
                <a
                  href="https://docs.sine.space/world-streaming/troubleshooting#no-devices-detected-wrong-device-1"
                  target="_blank"
                >
                  Click here for tips
                </a>
              </div>
            </div>
          </div>
          <hr />
          <div class="itemContent contentFlex">
            <div>
              <img
                :src="
                  audioNetworking != 'Connection Established'
                    ? checkWrongImg
                    : checkRightImg
                "
              />
            </div>
            <div>
              <div class="midTitle">Audio Networking</div>
              <div class="itemsInner">{{ audioNetworking }}</div>
            </div>
          </div>
          <hr />
          <div class="itemContent contentFlex">
            <div>
              <img
                :src="audioError.length > 0 ? checkWrongImg : checkRightImg"
              />
            </div>
            <div>
              <div class="midTitle">Audio Volume</div>
              <div class="pids-wrapper">
                Mic Volume:
                <div class="pid"></div>
                <div class="pid"></div>
                <div class="pid"></div>
                <div class="pid"></div>
                <div class="pid"></div>
                <div class="pid"></div>
                <div class="pid"></div>
                <div class="pid"></div>
                <div class="pid"></div>
                <div class="pid"></div>
                {{ volume }}
              </div>
            </div>
          </div>
        </div>
        <br /><br />
        <div class="contentBody">
          <div class="itemContent">
            <div class="midTitle">Speaker</div>
            <div>
              <select
                class="spakerSelect"
                @change="outputChange"
                v-model="speakerSelected"
              >
                <option
                  v-for="(device, i) in outputDevices"
                  :value="device.value"
                  :key="i"
                >
                  {{ device.label }}
                </option>
              </select>
            </div>
            <div class="itemsInner" v-show="audioError.length > 0">
              {{ audioError }}
            </div>
            <div>
              <button
                class="ringBtn"
                :class="{ hand: !isPlaying }"
                id="testAudio"
                @click="playAudio"
              >
                {{ testRingText }}
              </button>
            </div>
          </div>
        </div>
        <br />
        <!-- <div v-if="appIdValid" id="goEmbed">
          <a :href="'/embed#/?id=' + appId" class="button">Join World</a>
        </div> -->
      </div>
    </div>
    <div id="footer">
      <div style="display: none">
        <button @click="getMedia()">getMedia</button>
        <label> <input type="checkbox" v-model="hidePanel" />hidePanel </label>
        <label> <input type="checkbox" v-model="watchDog" />watchDog </label>
      </div>
      <!-- <button onclick="getLocalDevices()">getLocalDevices</button> -->
    </div>
    <div style="display: none">
      <audio id="ringVideo" :src="ring" ref="audioFun"></audio>
    </div>
  </div>
</template>

<script>
import a4 from "agora-rtc-sdk-ng";
import {
  HiFiAudioAPIData,
  HiFiCommunicator,
  Point3D,
  OrientationEuler3D,
  HiFiLogger,
  HiFiLogLevel,
  UserDataSubscription,
  AvailableUserDataSubscriptionComponents,
} from "hifi-spatial-audio";

export default {
  name: "Detect",
  data() {
    return {
      debugMode: process.env.VUE_APP_DEBUG,
      videoStatus: "Disconnect",
      audioStatus: "Disconnect",
      videoName: "unknown",
      audioName: "unknown",
      errorText: "",
      ring: require("@/assets/Audio/du.mp3"),
      testRingText: "Click to test speakers",
      isPlaying: false,
      appId: "",

      audioContext: null,
      analyser: null,
      microphone: null,
      javascriptNode: null,

      inputDevices: [],
      outputDevices: [],
      cameraDevices: [],

      volume: 0,
      all_pids: null,

      agoraStatus: "DISCONNECTED",
      vivoxStatus: "DISCONNECTED",
      cntStatus: {
        dcnted: "DISCONNECTED",
        cnting: "CONNECTING",
        cnted: "CONNECTED",
        dcnting: "DISCONNECTING",
      },
      hidePanel: true,
      watchDog: true,
      micEnabled: true,
      webcamEnable: true,
      screenEnable: false,
      audioStream: null,

      cameraSelected: "",
      microphoneSelected: "",
      speakerSelected: "",
      checkRightImg: require("@/assets/Images/checkRight.png"),
      checkWrongImg: require("@/assets/Images/checkWrong.png"),
      videoNetworking: "Initialising",
      videoError: "Initialising",
      audioNetworking: "Initialising",
      audioError: "Initialising",

      receiveChannel: "testerroom",
      uid: 2210291,
      //agora client
      appId: "7b2529cb5e5a4abbb3b06cc2f277209f",
      rtc: {
        client: null,
        localAudioTrack: null,
        localScreenTrack: null,
        localWebcamTrack: null,
        remoteAudioTrack: [],
        published: false,
      },

      //hifi config
      hifiCommunicator: null,
      hifiApiUrl: "loadbalancer-audio-0.swe-voice2.com",
    };
  },
  computed: {
    errorTextShow: function () {
      return this.errorText.length > 0;
    },
    appIdValid: function () {
      return new RegExp(/^\d{3}\.\d{3}$/).test(this.appId);
    },
    hifiAppId: function () {
      let appid = "8cedba9b-9e9d-4503-a930-b46c70b53b31";
      if (true) appid = "d0cc0f3a-c8f7-4e62-9a08-3d419fa3ed43";
      return appid;
    },
    hifiAppSecret: function () {
      let appid = "cb56a9e4-d465-4dab-bc00-6d40517fccd1";
      if (true) appid = "f80737df-fbfc-4857-b2c4-9ab3172f982a";
      return appid;
    },
  },
  watch: {},
  created: function () {
    console.log(window.location.protocol);
    if (!this.debugMode && window.location.protocol == "http:") {
      let httpUrl = window.location.href;
      let httpsUrl = "https:" + httpUrl.substring(5, httpUrl.length);
      console.log(httpsUrl);
      window.location.href = httpsUrl;
      return;
    }

    console.log(this.$route.query.appid);
    if (typeof this.$route.query.appid == "undefined") {
      // this.$router.push({ name: "Plan" });
    } else {
      this.appId = this.$route.query.appid;
    }

    var head = document.getElementsByTagName("head")[0];
    let url =
      process.env.VUE_APP_CSS_MAIN_PATH + "/assets_v2/2019/css/custom.css";
    var link = document.createElement("link");
    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = url;
    head.appendChild(link);

    document.title = "Breakroom: Voice and Video Tester";
  },
  mounted: async function () {
    this.all_pids = document.querySelectorAll(".pid");
    this.all_pids = Array.prototype.slice.call(this.all_pids, 0);

    this.getMedia();

    setInterval(() => {
      if (this.audioNetworking == "Initialising") {
        return;
      }
      if (this.audioNetworking != "Connection Established") {
        this.hifiConnect();
      }
    }, 6000);
  },
  methods: {
    initDevices() {
      navigator.mediaDevices
        .enumerateDevices()
        .then(this.getDevices)
        // .then(this.inputChange)
        .catch(this.handleError);
    },
    getDevices(deviceInfos) {
      this.inputDevices = [];
      this.outputDevices = [];
      this.cameraDevices = [];

      console.log(deviceInfos);
      let micCount = 1;
      let hasDeviceId = false;
      for (let i = 0; i !== deviceInfos.length; ++i) {
        const deviceInfo = deviceInfos[i];
        if (deviceInfo.kind === "audioinput") {
          if (deviceInfo.deviceId == this.getLocalStorageItem("microphoneId")) {
            hasDeviceId = true;
          }
          this.inputDevices.push({
            label: deviceInfo.label || `microphone ${micCount}`,
            value: deviceInfo.deviceId,
          });
          micCount++;
        }
      }
      this.microphoneSelected = hasDeviceId
        ? this.getLocalStorageItem("microphoneId")
        : this.inputDevices[0].value;

      let speakerCount = 1;
      hasDeviceId = false;
      for (let i = 0; i !== deviceInfos.length; ++i) {
        const deviceInfo = deviceInfos[i];
        if (deviceInfo.kind === "audiooutput") {
          if (deviceInfo.deviceId == this.getLocalStorageItem("speakerId")) {
            hasDeviceId = true;
          }
          this.outputDevices.push({
            label: deviceInfo.label || `speaker ${speakerCount}`,
            value: deviceInfo.deviceId,
          });
          speakerCount++;
        }
      }
      let firstSpeakerId =
        this.outputDevices.length == 0 ? "" : this.outputDevices[0].value;
      this.speakerSelected = hasDeviceId
        ? this.getLocalStorageItem("speakerId")
        : firstSpeakerId;

      let cameraCount = 1;
      hasDeviceId = false;
      for (let i = 0; i !== deviceInfos.length; ++i) {
        const deviceInfo = deviceInfos[i];
        if (deviceInfo.kind === "videoinput") {
          if (this.$parent.inputVideoDeviceId == "") {
            this.$parent.inputVideoDeviceId = deviceInfo.deviceId;
          }
          if (deviceInfo.deviceId == this.getLocalStorageItem("cameraId")) {
            hasDeviceId = true;
          }
          this.cameraDevices.push({
            label: deviceInfo.label || `camera ${cameraCount}`,
            value: deviceInfo.deviceId,
          });
          cameraCount++;
        }
      }
      this.cameraSelected = hasDeviceId
        ? this.getLocalStorageItem("cameraId")
        : this.cameraDevices[0].value;
    },
    async getMedia() {
      let that = this;
      let constraints = {
        video: false,
        audio: { deviceId: this.getLocalStorageItem("microphoneId") },
      };

      let promiseAudio = navigator.mediaDevices.getUserMedia(constraints);
      promiseAudio
        .then(function (MediaStream) {
          that.initDevices();
          that.audioStream = MediaStream;
          that.audioContext = new AudioContext();
          that.analyser = that.audioContext.createAnalyser();
          that.microphone =
            that.audioContext.createMediaStreamSource(MediaStream);
          that.javascriptNode = that.audioContext.createScriptProcessor(
            2048,
            1,
            1
          );
          that.analyser.smoothingTimeConstant = 0.8;
          that.analyser.fftSize = 1024;
          that.microphone.connect(that.analyser);
          that.analyser.connect(that.javascriptNode);
          that.javascriptNode.connect(that.audioContext.destination);
          that.javascriptNode.onaudioprocess = function () {
            var array = new Uint8Array(that.analyser.frequencyBinCount);
            that.analyser.getByteFrequencyData(array);
            var values = 0;
            var length = array.length;
            for (var i = 0; i < length; i++) {
              values += array[i];
            }
            var average = values / length;
            that.volume = Math.round(average);
            that.colorPids(average);
          };

          let a = MediaStream.getAudioTracks();
          that.audioName = a[0].label;
          that.audioStatus = "Connected";
          that.audioError = "";

          //set spaker
          that.attachSinkId(that.speakerSelected);

          that.hifiConnect();
        })
        .catch(function (PermissionDeniedError) {
          console.log(PermissionDeniedError);
          that.audioError = PermissionDeniedError.message;
        });

      let constraintsVideo = {
        video: { deviceId: this.getLocalStorageItem("cameraId") },
        audio: false,
      };
      console.log(constraintsVideo);
      let promiseVideo = navigator.mediaDevices.getUserMedia(constraintsVideo);
      promiseVideo
        .then(function (MediaStream) {
          that.initDevices();
          localWebcamVideo.srcObject = MediaStream;
          localWebcamVideo.play();

          let v = MediaStream.getVideoTracks();
          that.videoName = v[0].label;
          that.videoStatus = "Connected";
          that.videoError = "";
          that.agoraConnect();
        })
        .catch(function (PermissionDeniedError) {
          console.log(PermissionDeniedError);
          that.videoError = PermissionDeniedError.message;
          // error.style.display = "block";
        });
    },
    colorPids(vol) {
      let amout_of_pids = Math.round(vol / 10);
      let elem_range = this.all_pids.slice(0, amout_of_pids);
      for (var i = 0; i < this.all_pids.length; i++) {
        this.all_pids[i].style.backgroundColor = "#e6e7e8";
      }
      for (var i = 0; i < elem_range.length; i++) {
        // console.log(elem_range[i]);
        elem_range[i].style.backgroundColor = "#69ce2b";
      }
    },
    async agoraConnect() {
      console.log("agoraConnect");
      this.videoNetworking = "Initialising";

      try {
        console.log(this.receiveChannel);
        console.log(this.uid);

        this.rtc.client = AgoraRTC.createClient({ mode: "live", codec: "vp8" });
        this.rtc.client.on("connection-state-change", (evt) => {
          console.log("agora state:", evt);
          if (evt == "CONNECTED") {
            this.videoNetworking = "Connection Established";
          } else {
            this.videoNetworking = "Connection Error";
          }
        });
        let uid = await this.rtc.client.join(
          this.appId,
          this.receiveChannel,
          null,
          this.uid
        );

        console.log("agora await join: ", this.receiveChannel);
      } catch (error) {
        console.error(error);
      }
    },
    async hifiConnect() {
      if (this.audioNetworking == "Connection Established") {
        return;
      }
      console.log("hifiConnect");
      this.audioNetworking = "Initialising";
      let initialHiFiAudioAPIData = new HiFiAudioAPIData({
        position: new Point3D({ x: 0, y: 0, z: 0 }),
        orientationEuler: new OrientationEuler3D({
          pitch: 0,
          yaw: 0,
          roll: 0,
        }),
      });
      this.hifiCommunicator = new HiFiCommunicator({
        initialHiFiAudioAPIData: initialHiFiAudioAPIData,
        onConnectionStateChanged: this.onConnectionStateChanged,
      });

      try {
        var jwt = require("jsonwebtoken");
        let data = {
          user_id: this.uid,
          app_id: this.hifiAppId,
          space_name: this.receiveChannel,
          admin: false,
          space_template_name: "Template-for-150-Users",
        };
        var token = jwt.sign(data, this.hifiAppSecret);
        let connectResult =
          await this.hifiCommunicator.connectToHiFiAudioAPIServer(
            token,
            this.hifiApiUrl
          );
        console.log(connectResult);
        if (connectResult.success) {
          this.audioNetworking = "Connection Established";
        } else {
          this.audioNetworking = "Connection Error";
          throw "connect error:" + connectResult.error;
        }
      } catch (e) {
        console.error(`Error connecting to High Fidelity:` + e.error);
        this.audioNetworking = "Connection Error";
        return;
      }
    },
    onConnectionStateChanged(val) {
      console.log("hifi state:", val);
      if (val == "CONNECTED") {
        this.audioNetworking = "Connection Established";
      } else {
        this.audioNetworking = "Connection Error";
      }
    },
    updateAgoraStatus: function (val) {
      this.agoraStatus = val;
    },
    updateVivosStatus: function (val) {
      this.vivoxStatus = val;
    },
    playAudio: function () {
      this.testRingText = "playing";
      this.isPlaying = true;
      this.$refs.audioFun.play();
      setTimeout(() => {
        this.testRingText = "Click to test speakers";
        this.isPlaying = false;
      }, 4000);
    },
    cameraChange: async function (e) {
      console.log(e.target.value);
      localStorage.setItem("cameraId", e.target.value);
      let constraintsVideo = {
        video: { deviceId: e.target.value },
        audio: false,
      };
      try {
        let videoStream = await navigator.mediaDevices.getUserMedia(
          constraintsVideo
        );
        localWebcamVideo.srcObject = videoStream;
        localWebcamVideo.play();

        let v = videoStream.getVideoTracks();
        this.videoName = v[0].label;
        this.videoStatus = "Connected";
        this.videoError = "";
      } catch (error) {
        console.log(error);
        this.videoError = error.message;
      }
    },
    inputChange: async function (e) {
      console.log(e.target.value);
      localStorage.setItem("microphoneId", e.target.value);
      let that = this;
      if (that.audioStream != null) {
        const tracks = that.audioStream.getTracks();
        tracks.forEach((track) => {
          track.stop();
        });
        that.audioStream = undefined;
      }
      let constraintsVideo = {
        video: false,
        audio: { deviceId: e.target.value },
      };
      try {
        that.audioStream = await navigator.mediaDevices.getUserMedia(
          constraintsVideo
        );
        that.audioContext = new AudioContext();
        that.analyser = that.audioContext.createAnalyser();
        that.microphone = that.audioContext.createMediaStreamSource(
          that.audioStream
        );
        that.javascriptNode = that.audioContext.createScriptProcessor(
          2048,
          1,
          1
        );
        that.analyser.smoothingTimeConstant = 0.8;
        that.analyser.fftSize = 1024;
        that.microphone.connect(that.analyser);
        that.analyser.connect(that.javascriptNode);
        that.javascriptNode.connect(that.audioContext.destination);
        that.javascriptNode.onaudioprocess = function () {
          var array = new Uint8Array(that.analyser.frequencyBinCount);
          that.analyser.getByteFrequencyData(array);
          var values = 0;
          var length = array.length;
          for (var i = 0; i < length; i++) {
            values += array[i];
          }
          var average = values / length;
          that.volume = Math.round(average);
          that.colorPids(average);
        };

        let a = that.audioStream.getAudioTracks();
        that.audioName = a[0].label;
        that.audioStatus = "Connected";
        that.audioError = "";
      } catch (error) {
        console.log(error);
        this.audioError = error.message;
      }
    },
    outputChange: function (event) {
      console.log(event.target);
      const deviceId = event.target.value;
      localStorage.setItem("speakerId", deviceId);
      this.attachSinkId(deviceId);
    },
    attachSinkId: function (sinkId) {
      const element = document.querySelectorAll("audio");
      for (let i = 0; i < element.length; i++) {
        if (typeof element[i].sinkId !== "undefined") {
          element[i]
            .setSinkId(sinkId)
            .then(() => {
              console.log(
                `Success, audio output device attached: ${sinkId} to element with ${element[i].title} as source.`
              );
            })
            .catch((error) => {
              let errorMessage = error;
              if (error.name === "SecurityError") {
                errorMessage = `You need to use HTTPS for selecting audio output device: ${error}`;
              }
              console.error(errorMessage);
            });
        } else {
          console.warn("Browser does not support output device selection.");
        }
      }
    },
    getLocalStorageItem: function (key) {
      return localStorage.getItem(key) == null ? "" : localStorage.getItem(key);
    },
  },
  beforeDestroy: function () {
    this.watchDog = false;
  },
};
</script>

<style scoped>
#container {
  zoom: 0.7;
  font-family: "Cairo";
  width: calc(100% - 100px);
  min-width: 968px;
  margin: 0 auto;
  padding: 90px 140px;
  height: 100%;
  font-size: 16px;
}
.title {
  font-family: "Montserrat";
  font-weight: bold;
  line-height: 48px;
  color: #333333;
  font-size: 48px;
}
.subTitle {
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
}
.subTitle > div {
  width: 47%;
}
.itemsTitle {
  margin-bottom: 14px;
  font-size: 24px;
  font-family: "Montserrat";
  font-weight: bold;
  line-height: 28px;
  color: #333333;
}
.itemsInner {
  font-size: 20px;
  font-family: "Cairo";
  font-weight: 400;
  line-height: 30px;
  color: #333333;
}
.itemsInner > a {
  font-weight: 700;
  color: #2196f3;
}
.midTitle {
  margin-bottom: 10px;
  font-family: "Montserrat";
  font-size: 22px;
  font-weight: 700;
  line-height: 27px;
}
.body {
  display: flex;
  min-height: 470px;
  min-width: 968px;
  height: 400px;
  justify-content: space-between;
  padding: 70px 0;
}
select {
  height: 50px;
  width: 100%;
  padding: 0 20px;
  font-size: 20px;
  font-family: "Cairo";
  font-weight: 600;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background: url("../assets/Images/arrow-b.png") no-repeat scroll right 1rem
    center #f4f5f7;
  margin: 10px 0;
  border-radius: 4px;
  border: none;
}
.videoCol {
  width: 47%;
}
.contentBody {
  padding: 6px;
  border: 1px #e5e5e5 solid;
  border-radius: 3px;
}
.contentFlex {
  display: flex;
}
.contentFlex > div:first-child {
  width: 40px;
  flex-shrink: 0;
}
#localWebcamVideo {
  margin-top: 20px;
  border-radius: 3px;
  background-color: black;
}
.textCol {
  width: 47%;
}
#footer {
  clear: left;
}
.hide {
  display: none;
}
#goEmbed {
  text-align: center;
}
.pid {
  width: 8px;
  height: 12px;
  display: inline-block;
  background-color: #e6e7e8;
}
.hand {
  cursor: pointer;
}
.errorInfo {
  color: red;
  font-size: 18px;
}
hr {
  height: 0px;
  border-top: 1px solid #f2f2f2;
  border-right: 0px;
  border-bottom: 0px;
  border-left: 0px;
}
.itemContent {
  padding: 16px 24px;
}
.ringBtn {
  width: 270px;
  padding: 20px 40px;
  background: #2196f3;
  border-radius: 99px;
  border-width: 0;
  color: white;
  font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/components/Detect.vue